import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { UserNotificationPreference } from '../types/notification';

type GetUserNotificationPreferencesResponse = {
    preferences: UserNotificationPreference;
};

async function getUserNotificationPreferences(): Promise<GetUserNotificationPreferencesResponse> {
    const { data } = await api.get(`/notification-preferences`);
    return data;
}

export function useUserNotificationPreferences(): UseQueryResult<GetUserNotificationPreferencesResponse, AxiosError> {
    return useQuery(['user-notification-preferences'], getUserNotificationPreferences, {
        keepPreviousData: true,
    });
}
